import React from "react";
import PlanningList from "../Contents/Planning/PlanningItem/PlanningList";
import FaIcon from "../Elements/FaIcon";
import Link from "../Elements/link";
import RateMicroGraph from "../Elements/RateMicroGraph";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import mathHelper from "../Helpers/mathHelper";
import statusHelper from "../Helpers/statusHelper";
import stringHelper from "../Helpers/stringHelper";
import LongText from '../Elements/LongText';

export default class ServiceItem
{
  constructor (item)
  {
    this.VPlanningServiceItemId = item.vplanningServiceItemId;
    this.OpportunityId = item.opportunityId;
    this.ClientId = item.clientId;
    this.OfficeId = item.officeId;
    this.ClientName = item.clientName;
    this.OpportunityName = item.opportunityName;
    this.ServiceName = item.serviceName;
    this.OfficeName = item.officeName;
    this.OpportunityStatusCode = item.opportunityStatusCode;
    this.OpportunityStatus = item.opportunityStatus;
    this.OpportunityModifiedOn = item.opportunityModifiedOn;
    this.OpportunityModifiedBy = item.opportunityModifiedBy;
    this.UserName = item.userName;
    this.NumberOfPlanningItems = item.numberOfPlanningItems;
    this.NumberOfPlanningDetails = item.numberOfPlanningDetails;

    this.NumberOfAssignmentsContracted = item.numberOfAssignmentsContracted;
    this.NumberOfAssignmentsAll = item.numberOfAssignmentsAll;
    this.NumberOfAssignmentsCompleted = item.numberOfAssignmentsCompleted;
    this.NumberOfAssignmentsFinalized = item.numberOfAssignmentsFinalized;
    this.NumberOfAssignmentsExcluded = item.numberOfAssignmentsExcluded;
    this.NumberOfAssignmentsInvoiced = item.numberOfAssignmentsInvoiced;
    this.NumberOfAssignmentsPlanned = item.numberOfAssignmentsPlanned;

    this.OpportunityActualStartOn = item.opportunityActualStartOn;
    this.OpportunityActualEndOn = item.opportunityActualEndOn;
    this.OpportunityIndustryCode = item.opportunityIndustryCode;
    this.OpportunityIndustry = item.opportunityIndustry;
    this.ClientAcctMgrId = item.clientAcctMgrId;
    this.RevenueContracted = item.revenueContracted;
    this.RevenuePlanned = item.revenuePlanned;
    this.RevenueInvoiced = item.revenueInvoiced;
    this.OwningOfficeCurrency = item.owningOfficeCurrency;
    this.Status = item.status;

    this.PercentageOfAssignedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsAll,
      this.NumberOfAssignmentsContracted
    );
    this.PercentageOfCompletedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsCompleted,
      this.NumberOfAssignmentsContracted
    );
    this.PercentageOfFinalizedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsFinalized,
      this.NumberOfAssignmentsContracted
    );
    this.PercentageOfInvoicedAssignments = mathHelper.PercentageText(
      this.NumberOfAssignmentsInvoiced,
      this.NumberOfAssignmentsContracted
    );
  }

  static MoneyFields = [ 'RevenueContracted', 'RevenuePlanned', 'RevenueInvoiced' ];

  static Currency ()
  {
    return 'OwningOfficeCurrency';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary ()
  {
    return 'OwningOfficeCurrency';
  }

  static DateFields = [ 'OpportunityModifiedOn', 'OpportunityActualStartOn', 'OpportunityActualEndOn' ];

  static Percentage (part, whole)
  {
    return `${parseInt(whole) === 0 ? 0 : parseInt((part / parseFloat(whole)) * 100)}%`;
  }

  static nameOfTheItemDetailList ()
  {
    return 'Planning Service';
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'ClientName', label: 'Client Name' },
        { name: 'OpportunityName', label: 'Opportunity Name' },
        { name: 'ServiceName', label: 'Service Name' },
        { name: 'OpportunityActualStartOn', label: 'Opportunity Start Date' },
        { name: 'OpportunityActualEndOn', label: 'Opportunity End Date' },
        { name: 'OfficeName', label: 'Owning Office' },
        { name: 'Status', label: 'Status' },
        { name: 'OpportunityIndustry', label: 'Client Industry' },
        { name: 'ClientAcctMgrId', label: 'Owner' },
      ],
    },
    {
      tabName: 'DetailsResults',
      tabLabel: 'Details & Results',
      icon: 'fa-solid fa-circle-info',
      data: [
        { name: '-', label: 'Details & Results' },
        { name: 'NumberOfAssignmentsContracted', label: 'Contracted Assignments' },
        { name: 'NumberOfAssignmentsPlanned', label: 'Planned Assignments' },
        { name: 'NumberOfAssignmentsInvoiced', label: 'Invoiced Assignments' },
        { name: 'RevenueContracted', label: 'Contracted Revenue' },
        { name: 'RevenuePlanned', label: 'Planned Revenue' },
        { name: 'RevenueInvoiced', label: 'Invoiced Revenue' },

        { name: '-message-', label: '' },
        {
          name: '-message-',
          label: 'The percentages are counted according to the number of the contracted assignments.',
        },
        { name: 'PercentageOfAssignedAssignments', label: 'Assigned Assignment %' },
        { name: 'PercentageOfCompletedAssignments', label: 'Completion %' },
        { name: 'PercentageOfFinalizedAssignments', label: 'Finalization %' },
        { name: 'PercentageOfInvoicedAssignments', label: 'Invoiced %' },
      ],
    },
  ];

  static NameOfTheIdField ()
  {
    return 'VPlanningServiceItemId';
  }

  static BoolFields = [
    'AllowBulkEmail',
    'AllowEmail',
    'AllowFax',
    'AllowPhone',
    'AllowPostalMail',
    'AllowSendMedia',
    'IsActive',
    'IsMspartner',
  ];

  static getMicrographCellContent (item)
  {
    if (item.NumberOfAssignmentsPlanned <= 0)
    {
      return null;
    }
    const numbers = [
      //Not assigned
      item.NumberOfAssignmentsPlanned - item.NumberOfAssignmentsAll,
      //Assigned but not completed
      item.NumberOfAssignmentsAll - item.NumberOfAssignmentsCompleted,
      //completed but not finalized
      item.NumberOfAssignmentsCompleted - item.NumberOfAssignmentsFinalized,
      //Finalized but not invoiced
      item.NumberOfAssignmentsFinalized - item.NumberOfAssignmentsInvoiced,
      //Invoiced
      item.NumberOfAssignmentsInvoiced,
      //Excluded
      item.NumberOfAssignmentsExcluded,
    ];
    const colors = [ 'Grey', 'Orange', 'Yellow', 'LightGreen', 'Green', 'Red' ];
    const names = [ 'Planned', 'Assigned', 'Completed', 'Finalized', 'Invoiced', 'Excluded' ];

    return (
      <RateMicroGraph
        numbers={numbers}
        colors={colors}
        names={names}
      />
    );
  }

  static getStatusCellContent (item)
  {
    return (
      <span>
        {statusHelper.getStatusColorIcon(item.Status)}
        {stringHelper.convertToWords(item.Status)}
      </span>
    );
  }

  static getDetailCellContent (item)
  {
    // return urlHelper.getIconLinkComponent(
    //   "Plannings "+item.NumberOfPlanningItems+"-"+item.NumberOfPlanningDetails,
    //   "fa-solid fa-arrow-up-right-from-square",
    //   "text-primary pl-1 pr-1",
    //   "planning_planningList/search",
    //   "ServiceId="+item.VPlanningServiceItemId,
    //   "Open up in a new tab"
    // )
    return (
      <Link
        linktext={`Plannings ${item.NumberOfPlanningItems}-${item.NumberOfPlanningDetails}`}
        title={
          <span>
            <FaIcon iconName='fa-solid fa-screwdriver' /> Planning - Planning Items
          </span>
        }
        link={<PlanningList serviceId={item.VPlanningServiceItemId} />}
        url={`planning_planningList/search?ServiceId=${item.VPlanningServiceItemId}`}
      />
    );
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  //   In the following example the FreelancerUserItem.editFunction function is a static variable in this class, so you can change its value
  //   I change the value in the constructor of the FreelancerUserAdmin component
  static FieldsToShowInDataTable ()
  {
    return [
      {
        label: 'ServiceId',
        orderById: 'VPlanningServiceItemId',
        data: 'VPlanningServiceItemId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      { label: 'Client Name', orderById: 'ClientName', data: 'ClientName' },
      {
        label: 'Opportunity Name',
        orderById: 'OpportunityName',
        data: (item) => (
          <LongText
            text={`${item.OpportunityName} (${item.OpportunityId})`}
            maxLength={40}
          />
        ),
      },
      { label: 'Service Name', orderById: 'ServiceName', data: 'ServiceName' },
      { label: 'Office', orderById: 'OfficeName', data: (item) => item.OfficeName.replace('BARE ', ''), minWidth: 60 },
      { label: 'Modified By', orderById: 'UserName', data: 'UserName', minWidth: 70 },
      { label: 'Modified', orderById: 'OpportunityModifiedOn', data: 'OpportunityModifiedOn', minWidth: 60 },
      { label: 'Graph', orderById: '', data: ServiceItem.getMicrographCellContent, minWidth: 70 },
      { label: 'Status', orderById: '', data: ServiceItem.getStatusCellContent },
      { label: 'Plannings', orderById: '', data: ServiceItem.getDetailCellContent },
    ];
  }
}
